import React, { useEffect, useState } from 'react';
import NewspaperLayout from './NewspaperLayout';
import NewspaperLayoutInv from './NewspaperLayoutInv';
import { supabase } from '../client/client';

const LIGHT_FIELDS = 'id, number, title, written_by, category_id, image_url, created_at, updated_at, fecha_publicacion';

const Noticias = () => {
    const [categoriesData, setCategoriesData] = useState([]);
    const [newsCategory1, setNewsCategory1] = useState([]);
    const [newsCategory3, setNewsCategory3] = useState([]);
    const [newsCategory5, setNewsCategory5] = useState([]);
    const [newsCategory2, setNewsCategory2] = useState([]);
    const [newsCategory4, setNewsCategory4] = useState([]);

    useEffect(() => {
        const fetchNewsByCategory = async (categoryId) => {
            const { data, error } = await supabase
                .from('news')
                .select(LIGHT_FIELDS)
                .eq('category_id', categoryId)
                .in('number', [1, 2, 3])
                .order('created_at', { ascending: false })
                .limit(20);

            if (error) {
                console.error(`Error fetching news category ${categoryId}:`, error);
                return [];
            }
            return data || [];
        };

        const loadAll = async () => {
            const { data: categories, error: categoriesError } = await supabase
                .from('categorias')
                .select('id, name, color')
                .order('id');

            if (categoriesError) {
                console.error('Error fetching categories:', categoriesError);
            } else {
                setCategoriesData(categories || []);
            }

            const [c1, c2, c3, c4, c5] = await Promise.all([
                fetchNewsByCategory(1),
                fetchNewsByCategory(2),
                fetchNewsByCategory(3),
                fetchNewsByCategory(4),
                fetchNewsByCategory(5),
            ]);

            setNewsCategory1(c1);
            setNewsCategory2(c2);
            setNewsCategory3(c3);
            setNewsCategory4(c4);
            setNewsCategory5(c5);
        };

        loadAll();
    }, []);

    return (
        <div className="newspaper-layout">
            <NewspaperLayout newsData={newsCategory1} categoriesData={categoriesData} />
            <NewspaperLayoutInv newsData={newsCategory2} categoriesData={categoriesData} />
            <NewspaperLayout newsData={newsCategory3} categoriesData={categoriesData} />
            <NewspaperLayoutInv newsData={newsCategory4} categoriesData={categoriesData} />
            <NewspaperLayout newsData={newsCategory5} categoriesData={categoriesData} />
        </div>
    );
};

export default Noticias;
